"use client"

import { ComponentConfig } from "@measured/puck"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export interface CareerItem {
  title: string
  description: string
  link: string
}

export interface CareerProps extends CommonStylesProps {}

export const Career: ComponentConfig<CareerProps> = {
  label: "Tamda Group | Career",
  fields: {
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    className: "",
  },
  ...RenderConfig,
}
